<p-tree
  class="kl-tree"
  [value]="value()"
  [selectionMode]="selectionMode()"
  [selection]="selection()"
  (selectionChange)="onSelectionChange($event)"
  [propagateSelectionUp]="propagateSelectionUp()"
  [propagateSelectionDown]="propagateSelectionDown()"
  [scrollHeight]="scrollHeight()"
  [filter]="filter()"
  [filterMode]="filterMode()"
  [filterPlaceholder]="filterPlaceholder()" />
